import { FC, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'redux/store'
import { Box, CssBaseline } from '@mui/material'

import Header from 'components/organisms/layout/Header'
import Navigation from 'components/organisms/layout/Navigation'
import Main from 'components/organisms/layout/Main'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorBoundaryMessage } from 'components/atoms/ErrorBoundaryMessage'
import LayoutSkeleton from 'components/atoms/loaders/LayoutSkeleton'
import AlertMessage from 'components/atoms/AlertMessage'
import Notifications from './Notifications'
import SideBar from './SideBar'
import Breadcrumbs from './Breadcrumbs'

import { useGET_gradeScaleQuery } from 'redux/api/gradeScaleApi'
import { useGET_mySchoolQuery } from 'redux/api/mySchoolApi'
import { setSchool, setGradeScale } from 'redux/ui/common/userUI'


interface IProps {
  isLoading: boolean
  userToken: string
}

const Layout: FC<IProps> = ({ isLoading, userToken }) => {

  const dispatch = useDispatch<AppDispatch>()

  const userData = useSelector((state: RootState) => state['user'].user)
  const { data: schoolData } = useGET_mySchoolQuery(null,{skip: !userData})
  const { data: gradeScale } = useGET_gradeScaleQuery({page: 1, page_size: 999},{skip: !userData})

  useEffect(() => {
    dispatch(setSchool(schoolData))
  }, [schoolData]);

  useEffect(() => {
    if(gradeScale)
      dispatch(setGradeScale(gradeScale.results))
  }, [gradeScale]);


  const alertMessages = useSelector((state: RootState) => state.alert.messages) || [{message: 'Oops! Something went wrong.'}]
  const alertTime = useSelector((state: RootState) => state.alert.time)
  const alertType = useSelector((state: RootState) => state.alert.type)


  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <CssBaseline />
      {isLoading ? (
        <LayoutSkeleton />
      ) : (
        <>
          {userToken && <Header />}
          {userToken && <Navigation />}
          {userToken && <Notifications />}
          {userToken && <SideBar />}
          <Main userToken={userToken}>
            <ErrorBoundary FallbackComponent={ErrorBoundaryMessage}>
              <Breadcrumbs />
              <Outlet />
            </ErrorBoundary>
          </Main>
          {(alertMessages?.length > 0 || Object.entries(alertMessages)?.length > 0) && (
            <AlertMessage messages={{ data: alertMessages }} type={alertType} time={alertTime} />
          )}
        </>
      )}
    </Box>
  )
}

export default Layout
